// extracted by mini-css-extract-plugin
export default {"Card":"LessonMobile_Card__p8qIG","ImageContainer":"LessonMobile_ImageContainer__GldLy","InfoContainer":"LessonMobile_InfoContainer__ggc0E"};